<template>
  <card>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4>Roles & Permission</h4>
      <div v-if="isUnsavedChanges"  class="unsaved-changes-label">
        Unsaved Changes
      </div>
    </div>
    <!-- <br />
    <quick-setup />
    <br /> -->
    <table-wrapper title="Menu Dashboard">
      <internal-checkbox
        v-for="(permission, index) in permissionsInternalApp"
        :permission="permission"
        :key="index"
        @change="handleChange($event, 'internal')"
        :permissionValue="permissionValue['internal']"
      />
    </table-wrapper>
    <br />
    <table-wrapper title="Menu Mobile App">
      <non-internal-checkbox
        v-for="(permission, index) in permissionMobileApp"
        :permission="permission"
        :key="index"
        @change="handleChange($event, 'mobile')"
        :permissionValue="permissionValue['mobile']"
      />
    </table-wrapper>
    <br />
    <table-wrapper title="Menu Desktop App">
      <non-internal-checkbox
        v-for="(permission, index) in permissionDesktopApp"
        :permission="permission"
        :key="index"
        @change="handleChange($event, 'desktop')"
        :permissionValue="permissionValue['desktop']"
      />
    </table-wrapper>
  </card>
</template>

<script>
import { Card } from "../../../Layout";
import TableWrapper from "./TableWrapper.vue";
import { SingleSelect } from "../../../Input";
import QuickSetup from "./QuickSetup.vue";
import {
  Internal as InternalCheckbox,
  NonInternal as NonInternalCheckbox,
} from "./CheckboxWrapper";

export default {
  name: "RolesAndPermission",
  components: {
    Card,
    InternalCheckbox,
    NonInternalCheckbox,
    TableWrapper,
    SingleSelect,
    QuickSetup,
  },
  props: {
    permissionValue: {
      type: Object,
      required: true,
    },
    isUnsavedChanges: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      presetValue: "",
      permissionsInternalApp: [],
      permissionMobileApp: [],
      permissionDesktopApp: [],
    };
  },
  methods: {
    handleChange(value, type) {
      this.$emit("change", value, type);
    },
    getPermissionList() {
      this.$http
        .get(process.env.GET_EMPLOYEE_PERMISSION_LIST, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.permissionsInternalApp = response.data.content.internal;
            this.permissionMobileApp = response.data.content.mobile;
            this.permissionDesktopApp = response.data.content.desktop;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
  },
  mounted() {
    this.getPermissionList();
  },
};
</script>

<style scoped>
.unsaved-changes-label {
  background: #FFEDD5;
  padding: 2px 8px;
  color: #C2410C;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/RolesAndPermissions/index.vue